import LatheImage from './CNC/lathe.jpg';
import DrillingImage from './CNC/drilling.jpg';
import MachiningImage from './CNC/machining.jpg';
import MillingImage from './CNC/milling.jpg';
import RecommendCNC from './CNC/recommend.jpg';

import FDMImage from './Printing/FDM.jpg';
import MJFImage from './Printing/MJF.jpg';
import PolyjetImage from './Printing/Polyjet.jpg';
import SLAImage from './Printing/SLA.jpg';
import SLMImage from './Printing/SLM.jpg';
import SLSImage from './Printing/SLS.jpg';
import Recommend3D from './Printing/recommend.jpg';

import BlowImage from './Molding/blow.jpg';
import DoubleImage from './Molding/double.jpg';
import InsertImage from './Molding/insert.jpg';
import NormalImage from './Molding/normal.jpg';
import RecommendMolding from './Molding/recommend.jpg';

import LaserImage from './SheetMetal/laser.jpg';
import PressImage from './SheetMetal/press.jpg';
import WaterImage from './SheetMetal/water.jpg';
import RecommendSheetmetal from './SheetMetal/recommend.jpg';

import SandingImage from './Casting/Sanding.jpg';
import ShellImage from './Casting/Shell.jpg';
import InvestmentImage from './Casting/Investment.jpg';
import DieCastingImage from './Casting/DieCasting.jpg';
import CentrifugalImage from './Casting/Centrifugal.jpg';
import RecommendImage from './Casting/Recommend.jpg';

import PartnerImage from './partner.png';
export default {
  CNC: {
    LatheImage,
    DrillingImage,
    MachiningImage,
    MillingImage,
    RecommendCNC
  },
  Printing: {
    FDMImage,
    MJFImage,
    PolyjetImage,
    SLAImage,
    SLMImage,
    SLSImage,
    Recommend3D
  },
  Molding: {
    BlowImage,
    DoubleImage,
    InsertImage,
    NormalImage,
    RecommendMolding
  },
  SheetMetal: {
    LaserImage,
    PressImage,
    WaterImage,
    RecommendSheetmetal
  },
  Casting: {
    SandingImage,
    ShellImage,
    InvestmentImage,
    DieCastingImage,
    CentrifugalImage,
    RecommendImage
  },
  PartnerImage
};
